import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBk4fUiafaF_Vz7k_BGHdjAKBDtJgbH_Js",
  authDomain: "sidequestmeet.com",
  projectId: "sidequest-d36d6",
  storageBucket: "sidequest-d36d6.firebasestorage.app",
  messagingSenderId: "693184663704",
  appId: "1:693184663704:web:8e1018cce782496747c0ed"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;